import React from 'react'
import { useTranslation, useI18next } from 'gatsby-plugin-react-i18next'
import { TOptions } from 'i18next'
import htmr from 'htmr'
import Link from 'components/Link'

interface Props {
    id: string
    options?: TOptions
}

// Custom components mapping to be used by `htmr` when parsing the translation
// text
const transform = {
    a: Link,
}

// Renders the translation string for the given translation key `id`. It
// fallback to English if it doesn't find the given key in the current language
export const Translation = ({ id, options }: Props) => {
    const { language, i18n } = useI18next()
    const { t } = useTranslation()

    console.debug('translation language: ' + language)
    console.debug('translation id: ' + id)
    console.debug('translation namespaces: ' + JSON.stringify(i18n.reportNamespaces?.getUsedNamespaces))
    const translatedText = t(id, options)
    console.debug('translatedText : ' + translatedText)
    // Use `htmr` to parse html content in the translation text
    // @ts-ignore
    return <>{htmr(translatedText, { transform })}</>
}
